import { render, staticRenderFns } from "./MyWallet.vue?vue&type=template&id=81bb024a&scoped=true&"
import script from "./MyWallet.vue?vue&type=script&lang=js&"
export * from "./MyWallet.vue?vue&type=script&lang=js&"
import style0 from "./MyWallet.vue?vue&type=style&index=0&id=81bb024a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bb024a",
  null
  
)

export default component.exports